namespace Gamification.Gamification {
    export interface TipologieRisorseForm {
        Nome: Serenity.StringEditor;
        Descrizione: Serenity.TextAreaEditor;
    }

    export class TipologieRisorseForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.TipologieRisorse';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TipologieRisorseForm.init)  {
                TipologieRisorseForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;

                Q.initFormType(TipologieRisorseForm, [
                    'Nome', w0,
                    'Descrizione', w1
                ]);
            }
        }
    }
}
